<div class="row mb-2">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
                <div class="row">
                    <div class="col-lg-10 col-md-5 col-sm-5 mt-1">
                        <h4 class="mb-0 font-header">Active Session</h4>
                    </div>
                    <div class="col-lg-2 col-md-5 col-sm-5 mt-1 text-right"
                        *ngIf="global.OnboardingLoginType == 'agencyLogin'">
                        <button class="btn blue-btn" (click)="backToOperationalDashboard()"><i
                                class="fa fa-arrow-left mr-1"></i>Back</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mb-2">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <ejs-grid #gridactivesession [dataSource]='GridList | async' [allowPaging]='true'
                    [pageSettings]='initialPage' [allowResizing]='true' allowTextWrap='true'
                    [textWrapSettings]='wrapSettings' (dataStateChange)='dataChangeAs($event)' [allowFiltering]='false'
                    [allowSorting]='false' (actionBegin)="onActionAs($event)">
                    <e-columns>
                        <e-column minWidth=100 uid="action" textAlign="center" headerText="Actions"
                            [showInColumnChooser]='false'>
                            <ng-template #template let-data>
                                <button *ngIf="!data.isCurrentSession" class="btn blue-btn"
                                    (click)="revokeSessions(data)">Revoke</button>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="loginIp" headerText="Login Ip" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="loginAgent" headerText="Login Agent" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="loginTime" headerText="Login Time" type="date">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="lastUsedIp" headerText="Last Usedip" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="lastUsedAgent" headerText="Last Usedagent" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="lastUsedTime" headerText="Last Usedtime" type="date">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="isCurrentSession" textAlign="center"
                            headerText="Iscurrentsession">
                            <ng-template #template let-data>
                                <div *ngIf="data.isCurrentSession">

                                    <i class="fa fa-check" style="font-size:27px;color:green"></i>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</div>